import { render } from "./WithdrawInfo.vue?vue&type=template&id=fe876d54&scoped=true"
import script from "./WithdrawInfo.vue?vue&type=script&lang=js"
export * from "./WithdrawInfo.vue?vue&type=script&lang=js"

import "./WithdrawInfo.vue?vue&type=style&index=0&id=fe876d54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe876d54"]])

export default __exports__